export default __webpack_public_path__ + "static/media/colgate-palmolive-logo.5f0724a9.png";